import React, { useContext } from 'react';

import ThemeContext from 'modules/_shared/contexts/ThemeContext';

import { ReactComponent as Sun } from './Sun.svg';
import { ReactComponent as Moon } from './Moon.svg';
import './ThemeSwitcher.css';

export const setDarkMode = () => {
  document.querySelector('body')?.setAttribute('data-theme', 'dark');
  document.querySelector('body')?.classList.add('dark-mode');
  document.querySelector('.app-header')?.classList.remove('is-light');
  document.querySelector('.app-header')?.classList.add('is-dark');
  window.localStorage.setItem('app-theme', 'dark');
  window.dispatchEvent(new Event('storage'));
};

export const setLightMode = () => {
  document.querySelector('body')?.setAttribute('data-theme', 'light');
  document.querySelector('body')?.classList.remove('dark-mode');
  document.querySelector('.app-header')?.classList.remove('is-dark');
  document.querySelector('.app-header')?.classList.add('is-light');
  window.localStorage.setItem('app-theme', 'light');
  window.dispatchEvent(new Event('storage'));
};

export const selectedTheme = localStorage.getItem('app-theme');

const ThemeSwitcher = () => {
  const { darkTheme, toggleTheme: toggleThemeContext } =
    useContext(ThemeContext);

  if (selectedTheme === 'dark') {
    setDarkMode();
  } else {
    setLightMode();
  }

  const toggleTheme = (e: React.ChangeEvent<HTMLInputElement>) => {
    toggleThemeContext();
    if (e.target.checked) {
      setDarkMode();
    } else {
      setLightMode();
    }
  };

  return (
    <div className="dark_mode">
      <input
        className="dark_mode_input"
        type="checkbox"
        id="darkmode-toggle"
        onChange={toggleTheme}
        defaultChecked={selectedTheme === 'dark'}
      />
      <label className="dark_mode_label" htmlFor="darkmode-toggle">
        <Sun />
        <Moon />
      </label>
    </div>
  );
};

export default ThemeSwitcher;
